import { ComponentType, FC, ReactNode } from 'react';

import { RadarIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import { NotFoundStyle, NotFoundImageWrapper, NotFoundText } from './404Style';

export interface NotFoundProps {
  label?: string;
  icon?: ComponentType | ReactNode;
  iconSize?: number;
  className?: string;
}

const NotFound: FC<NotFoundProps> = ({
  icon = RadarIcon,
  label = '',
  iconSize,
  className,
}) => {
  return (
    <NotFoundStyle className={className}>
      <NotFoundImageWrapper>
        <CustomIcon icon={icon} fontSize={iconSize} />
      </NotFoundImageWrapper>

      <NotFoundText>{label}</NotFoundText>
    </NotFoundStyle>
  );
};

export default NotFound;
